import { render, staticRenderFns } from "./NonBusinessSeal.vue?vue&type=template&id=3fffe110&scoped=true"
import script from "./NonBusinessSeal.vue?vue&type=script&lang=js"
export * from "./NonBusinessSeal.vue?vue&type=script&lang=js"
import style0 from "./NonBusinessSeal.vue?vue&type=style&index=0&id=3fffe110&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fffe110",
  null
  
)

export default component.exports